<template>
  <div>
    <div>
      <span v-if="votingLimitRules.votingLimitOperator == rulesOptions.rulesOperators.et">
        Les deux limites doivent être respectées <strong>[et]</strong>
      </span>
      <span v-else> Au moins une des limites doit être respectée <strong>[ou]</strong> </span>
    </div>
    <ul>
      <li>
        Limite de mandats par participant:
        <strong>{{ votingLimitRules.votesLimitPerMandate }}</strong>
      </li>
      <li>
        Limite tantièmes par participant:
        <strong>
          {{ votingLimitRules.tantiemesLimitPerMandate }} [{{
            votingLimitRules.votingIncludesMandate == true
              ? "mandataire inclus"
              : "mandataire non inclus"
          }}]
        </strong>
        &nbsp;
        <em>(le nombre de tantiemes calculé en pourcentage)</em>
      </li>
    </ul>
    <div v-for="item in errorsVotingLimitRules" :key="item.id" class="my-1 text-danger">
      <b-alert :show="true" variant="danger">
        <strong>
          {{
            item.representant_owner_id
              ? getPersonNameAndGender({
                  personId: item.representant_owner_id,
                })
              : getPersonNameAndGender({
                  personId: item.representant_contact_id,
                  personType: "contact",
                })
          }}
        </strong>
        <div v-for="(error, index) in item.errors" :key="item.id + '' + index">
          {{ error.name }} : <strong>{{ error.value }}</strong>
        </div>
      </b-alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errorsVotingLimitRules: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
